export default (func: any) => (event: any) => {
  event.stopPropagation();
  func();
};
